export default "__VITE_ASSET__BxBydjLA__"